import produce, { Draft } from 'immer';

import { BuildsActionsType, IBuildsState, GOT_BUILDS } from '../types/build';

const initialBuildsState: IBuildsState = {
  builds: [],
};

export const buildsReducer = produce(
  (state: Draft<IBuildsState>, action: BuildsActionsType): void => {
    switch (action.type) {
      case GOT_BUILDS:
        state.builds = action.payload;
        break;
    }
  },
  initialBuildsState
);
